const AUTH_ERROR_MESSAGE_MAP = {
  "Invalid username or password.": "نام کاربری یا رمز عبور اشتباه است.",
  "Login from this IP is not allowed.": "ورود از این آی پی مجاز نیست.",
  "Request failed.": "درخواست انجام نشد. لطفا دوباره تلاش کنید.",
  "Network request failed": "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.",
};

export const localizeAuthErrorMessage = (message, fallbackMessage) => {
  const normalizedMessage = String(message || "").trim();
  if (!normalizedMessage) {
    return fallbackMessage;
  }

  return AUTH_ERROR_MESSAGE_MAP[normalizedMessage] || fallbackMessage;
};
